import Platform from '../base';
import navigationKeys from './config/keys/navigation';
import remoteKeys from './config/keys/remote-keys';
import storage from '../../helpers/storage';

class Vewd extends Platform {
  navigationKeys = navigationKeys;
  remoteKeys = remoteKeys;
  deviceInfo = {};

  initialize(opt) {
    super.initialize(opt);
  }

  exit = () => {
    window.close();
  };

  getFirmwareVersion() {
    return Platform.prototype.getFirmwareVersion();
  }

  // stub
  getModelYear() {
    return 1970;
  }

  getModelName() {
    try {
      let modelName = 'Vewd TV';

      const matches = navigator.userAgent.match(/Model\/(?=\S*['-])([a-zA-Z\d'-]+)/);

      if (matches && matches.length > 0) {
        modelName = matches[1];
      }
      return modelName;
    } catch (e) {
      return Platform.prototype.getModelName();
    }
  }

  getUID() {
    try {
      let duid = storage.get('duid');
      if (!duid) {
        duid = (
          Date.now().toString(36) +
          Math.random()
            .toString(36)
            .substr(2, 9)
        ).toUpperCase();
        storage.set('duid', duid);
      }
      return duid;
    } catch (e) {
      return Platform.prototype.getUID();
    }
  }

  getDeviceType() {
    return super.getDeviceType();
  }

  getDeviceRegistrationType() {
    return 'VEWD';
  }

  getPlatformVersion() {
    return 'Vewd TV';
  }

  getBrand() {
    return 'Vewd Store';
  }

  getName() {
    return 'Vewd';
  }

  isHisenseTVStoreOldModel() {
    return (
      navigator.userAgent.indexOf('Hisense') !== -1 &&
      navigator.userAgent.indexOf('TV Store') !== -1
    );
  }
}

export default Vewd;
